import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { coordinates: '_geoCoordinates' };
var _changeTemplateRequest = {};
var _changeTemplateResponse = {};
var _geoCoordinates = { latitude: 'DOUBLE', longitude: 'DOUBLE' };
var _introData = {
    createdDate: 'google.protobuf.Timestamp',
    address: '_address',
};
var _provisionRequest = { additionalIntroData: '_introData' };
var _provisionResponse = {};
function resolveWixApiFunnelIntroMetaSiteProvisionMetaSiteProvisionServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-site-provisioning-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/funnel-intro-site-provisioning-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-site-provisioning-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new MetaSiteProvisionDescriptor */
export function provision(payload) {
    var _a = serializer(_provisionRequest, {
        _address: _address,
        _geoCoordinates: _geoCoordinates,
        _introData: _introData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_provisionResponse, {}).fromJSON;
    function __provision(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_intro.v1.meta_site_provision_descriptor',
            method: 'POST',
            methodFqn: 'wix.api.funnel.intro.meta_site_provision.MetaSiteProvisionService.Provision',
            url: resolveWixApiFunnelIntroMetaSiteProvisionMetaSiteProvisionServiceUrl({ protoPath: '/v1/provision', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __provision.fromReq = fromReq;
    __provision.__isAmbassador = true;
    return __provision;
}
/** Changes the template of the existing MetaSite */
export function changeTemplate(payload) {
    var _a = serializer(_changeTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changeTemplateResponse, {}).fromJSON;
    function __changeTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_intro.v1.meta_site_provision_descriptor',
            method: 'POST',
            methodFqn: 'wix.api.funnel.intro.meta_site_provision.MetaSiteProvisionService.ChangeTemplate',
            url: resolveWixApiFunnelIntroMetaSiteProvisionMetaSiteProvisionServiceUrl({ protoPath: '/v1/template', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changeTemplate.fromReq = fromReq;
    __changeTemplate.__isAmbassador = true;
    return __changeTemplate;
}
//# sourceMappingURL=http.impl.js.map